import React, { Component } from "react";
import { Col } from 'react-bootstrap';
import Form from "react-validation/build/form";
import { Form as BSForm } from 'react-bootstrap';
import Input from "react-validation/build/input";
import TextArea from "react-validation/build/textarea";
import Select from "react-validation/build/select";
import CheckButton from "react-validation/build/button";
import { withRouter} from 'react-router-dom';

import { isEmail } from "validator";

import './ReservationForm.scss';

import { reserveLot, paymentLot, getReservationDetails, cancelReservation, getAgentsByUserCode, approveReservation } from '../../../api/Api.js';

import mixin from "../../../utils/mixin";
import consts from "../../../utils/constants";

const { methods } = mixin;

const required = value => {
  if (!value) {
    return (
      <div className="alert alert-danger" role="alert">
        Campo requerido.
      </div>
    );
  }
};

const requiredIndex = value => {
  if (value === '' || value === undefined || value === null) {
    return (
      <div className="alert alert-danger" role="alert">
        Campo requerido.
      </div>
    );
  }
};

const email = value => {
  if (!isEmail(value)) {
    return (
      <div className="alert alert-danger" role="alert">
        Ingresa un email válido.
      </div>
    );
  }
};

const positiveNumber = value => {
  if (isNaN(value) || value < 0) {
    return (
      <div className="alert alert-danger" role="alert">
        Ingresa un número válido.
      </div>
    );
  }
};

class ReservationForm extends Component {
  constructor(props) {
    super(props);
    
    this.state = {
      message: null,
      message_success: null,
      loading: false,
      lot: {},
      prev_lot_id: null,
      buyer: {},
      payment: {},
      address: {},
      payments: [],
      agents: [],
      selected_agent: null,
      reservation_agent: null,
      card_payment: true,
      card_number: '',
      card_year: '',
      card_month: '',
      card_cvv: '',
      card_message: '',
      invalid_card: false,
      loading_cancel: false,
      loading_confirm: false,
    };
  }
  
  handleSubmit = (e) => {
    e.preventDefault();

    this.setState({
      message: "",
      message_success: "",
      loading: true
    });

    if(window.confirm(`¿Estás seguro de completar la reservación del lote ${this.state.lot.name}?`)){
      this.form.validateAll();
      let validCard = true;
      if(this.state.card_payment){
        validCard = this.validateCardValues();
      }
      
      if (this.checkBtn.context._errors.length === 0 && validCard) {

        const lot_id = this.state.lot._id;

        let agent_id = null;
        let user_id = null;
        if(this.state.agents && this.state.agents.length > 0 && this.state.agents[this.state.selected_agent]){
          const agent = this.state.agents[this.state.selected_agent];
          agent_id = agent.type === 'agent' ? agent.agent_id : null; 
          user_id = agent.user_id;
        }

        let data = {
          buyer: this.state.buyer,
          payment: this.state.payment,
          address: this.state.address,
          agent: agent_id,
          user_id: user_id,
        }
        
        if(this.state.card_payment){
          data ={...data, ...{
            card:{
              card_number: this.state.card_number,
              card_year: this.state.card_year,
              card_month: this.state.card_month,
              card_cvv: this.state.card_cvv
            }
          }}
        }

        if(this.props.action == 'reserve'){
          if(this.state.card_payment){
            paymentLot({lot_id, data}).then(
              (res) => {
                if(res && res['transaction_id']){
                  if(res['status'] == 'APPROVED'){
                    
                    let lot = {...this.state.lot}
                    lot.status = 'SOLD';
                    lot.confirmed = true;
                    this.props.update(lot);
                    //this.props.close();
                    const payments = res['payments'];
                    this.setState({
                      loading: false,
                      lot: lot,
                      payments: payments,
                      message: null,
                      message_success: '¡Lote reservado correctamente!',
                    });

                  }else if(res['status'] == 'DECLINED'){
                    this.setState({
                      loading: false,
                      message: 'El pago ha sido declinado. Verifica la información e intenta de nuevo.'
                    });
                  }else {
                    this.setState({
                      loading: false,
                      message: 'El pago no pudo ser completado, ningún cargo fue aplicado. Intenta nuevamente.'
                    });  
                  }
                }else{
                  this.setState({
                    loading: false,
                    message: 'No se pudo reservar el lote. Intenta nuevamente.'
                  });
                }
              }
            );
          }else{
            reserveLot({lot_id, data}).then(
              (res) => {
                if(res && res['transaction_id'] && (res['status'] == 'APPROVED' || res['status'] == 'PENDING')){
                  let lot = {...this.state.lot}
                  lot.status = 'SOLD';
                  lot.confirmed = false;
                  this.props.update(lot);
                  //this.props.close();
                  const payments = res['payments'];
                  this.setState({
                    loading: false,
                    lot: lot,
                    payments: payments,
                  });
                }else{
                  this.setState({
                    loading: false,
                    message: 'No se pudo reservar el lote. Intenta nuevamente.'
                  });
                }
              }
            );
          }
        }

      } else {
        this.setState({
          loading: false
        });
      }
    } else {
      this.setState({
        loading: false
      });
    }
  }

  static getDerivedStateFromProps = (props, state) => {
    let l = {};
    
    if(props.lot_id !== state.prev_lot_id){
      
      if(props.lot){
        l = {...props.lot}
      }

      let price = 0;
      let discount = 0;
      let total = 0;

      if(props.action == 'view_reservation'){
        
        return{
          prev_lot_id: props.lot_id,
          lot: l,
          message: null,
          buyer: {},
          payment: {},
          address: {},
          payments: [],
          selected_agent: null,
          reservation_agent: null,
        }

      }else{

        if(props.lot.price){
          price = props.lot.price;
        }

        if(props.lot.discount){
          discount = props.lot.discount;
        }
        
        total = price - discount;

        let payment = {
          price: price,
          discount: discount,
          total: total
        }

        return{
          prev_lot_id: props.lot_id,
          lot: l,
          payment: payment,
          message: null,
        }
      }
    }

    return null;
  }

  componentDidUpdate(prevProps) {
    if (this.props.lot_id !== prevProps.lot_id && (this.props.user_code || this.props.agent != prevProps.agent)){
      this.getAgents();
    }
    if (this.props.lot_id !== prevProps.lot_id && this.props.action == 'view_reservation') {
      this.state.buyer = {};
      this.state.payment = {};
      this.state.address = {};
      this.state.payments = [];
      this.state.selected_agent = null;
      this.state.reservation_agent = null;
      this.getReservationInfo(this.props.lot_id);
    }
  }
  
  componentDidMount() {
    if (this.props.user_code){
      this.getAgents();
    }

    if (this.props.action == 'view_reservation') {
      this.setState({
        buyer: {},
        payment: {},
        address: {},
        payments: [],
        selected_agent: null,
        reservation_agent: null,
      });
      this.getReservationInfo(this.props.lot_id);
    }
  }

  getReservationInfo = (lot_id) => {
    getReservationDetails(lot_id).then(
      (res) => {
        let buyer= {}
        let payments = [];
        let payment = {};
        let address = {};
        let reservation_agent = null;
        let selected_agent = null;
        let card_payment = false;
        
        if(res && res['transaction_id']){
          card_payment = res['type'] == 'STRIPE';
          buyer = {
            first_name: res['first_name'],
            last_name: res['last_name'],
            last_name_2: res['last_name_2'],
            email: res['email'],
            phone: res['phone'],
          };
          payments = res['payments'];
          payment = {
            price: res['price'],
            discount: res['discount'],
            total: res['total'],
            notes: res['notes']
          };
          address = {
            country: res['address'] ? res['address']['country'] : '',
            state: res['address'] ? res['address']['state'] : '',
            city: res['address'] ? res['address']['city'] : '',
            line_1: res['address'] ? res['address']['line_1'] : '',
            line_2: res['address'] ? res['address']['line_2'] : '',
            zip_code: res['address'] ? res['address']['zip_code'] : ''
          };
          if(res['agent_id'] && res['agent']){
            reservation_agent = res['agent'];
          }else{
            reservation_agent = res['seller']
          }
        }else{
          this.setState({
            loading: false,
            message: 'No se pudo obtener la información de la reservación. Intenta nuevamente.',
            buyer: {},
            payments: [],
            payment: {},
            address: {},
            selected_agent: null,
            reservation_agent: null,
            card_payment: card_payment,
          });
        }
        
        this.setState({
          buyer: buyer,
          payments: payments,
          payment: payment,
          address: address,
          selected_agent: selected_agent,
          reservation_agent: reservation_agent,
          card_payment: card_payment,
        });

      }
    );
  }

  getAgents = () => {
    getAgentsByUserCode(this.props.user_code).then(
      (res) => {
        let agents = [];
        if (res) {
          agents = res;
        }

        let selected_agent = null;
        if(this.props.agent){
          const agent_id = this.props.agent.agent_id;
          const agent_type = this.props.agent.type;
          selected_agent = agents.findIndex(item => item.agent_id == agent_id && item.type == agent_type);
        }
        this.setState({
          agents: agents,
          selected_agent: selected_agent,
        });

      }
    );
  }

  getFillColor(p){
    let status =  this.props.status_array ? this.props.status_array.find(x => x.key == p.status) : null;
    
    if(status){
      return [status.red,status.green,status.blue];
    }
    
    return [108,117,125];
    
  }

  renderStatusLabel = () => {
    let status =  this.props.status_array ? this.props.status_array.find(x => x.key == this.state.lot.status) : null;
    let label = status ? status.label : '-';
    if(this.state.lot.status == 'SOLD' && this.state.lot.hasOwnProperty('confirmed') && this.state.lot.confirmed === false){
      label = 'Apartado en Proceso';
    }

    let color = this.getFillColor(this.state.lot);
    color = 'rgb(' + color[0] + ',' + color[1] + ',' + color[2] + ')';

    return (
      <span style={{backgroundColor: color, color:'white', fontSize:'12px', padding:'3px', borderRadius:'5px'}}>{label}</span>
    )
  }

  renderSimplePrice = (price) => {
    if(price){
      return(
        <span>{methods.G_renderPrice(price, 'MXN')}</span>
      )
    }
    return(
      <span>-</span>
    )
  }

  onChangeFirstName = (e) => {
    this.setState({
      buyer: {...this.state.buyer, ...{first_name: e.target.value}}
    });
  }

  onChangeLastName = (e) => {
    this.setState({
      buyer: {...this.state.buyer, ...{last_name: e.target.value}}
    });
  }

  onChangeLastName2 = (e) => {
    this.setState({
      buyer: {...this.state.buyer, ...{last_name_2: e.target.value}}
    });
  }

  onChangeEmail = (e) => {
    this.setState({
      buyer: {...this.state.buyer, ...{email: e.target.value}}
    });
  }

  onChangePhone = (e) => {
    this.setState({
      buyer: {...this.state.buyer, ...{phone: e.target.value}}
    });
  }

  onChangeCountry = (e) => {
    this.setState({
      address: {...this.state.address, ...{country: e.target.value}}
    });
  }

  onChangeState = (e) => {
    this.setState({
      address: {...this.state.address, ...{state: e.target.value}}
    });
  }

  onChangeCity = (e) => {
    this.setState({
      address: {...this.state.address, ...{city: e.target.value}}
    });
  }

  onChangeLine1 = (e) => {
    this.setState({
      address: {...this.state.address, ...{line_1: e.target.value}}
    });
  }

  onChangeLine2 = (e) => {
    this.setState({
      address: {...this.state.address, ...{line_2: e.target.value}}
    });
  }

  onChangeZipCode = (e) => {
    this.setState({
      address: {...this.state.address, ...{zip_code: e.target.value}}
    });
  }

  onChangeAgent = (e) => {
    this.setState({
      selected_agent: e.target.value
    });
  }

  onChangePrice = (e) => {
    const price = e.target.value;
    const total = this.state.payment.total = price - this.state.payment.discount;
    this.setState({
      payment: {...this.state.payment, ...{price: price, total: total}}
    });
  }
  
  onChangeDiscount = (e) => {
    const discount = e.target.value;
    const total = this.state.payment.price - discount;
    this.setState({
      payment: {...this.state.payment, ...{discount: discount, total: total}}
    });
  }

  onChangeNotes = (e) => {
    this.setState({
      payment: {...this.state.payment, ...{notes: e.target.value}}
    });
  }

  isEditable = () => {
    if(this.props.is_agent){
      return (
        this.state.lot.status != 'SOLD'
      );
    }
    return (
      this.state.lot.status != 'SOLD' && 
      (
        this.props.action == 'reserve' && methods.G_canDo(consts.Security.Action.CREATE_RESERVATION, localStorage.getItem('user')) ||
        this.props.action == 'view_reservation' && methods.G_canDo(consts.Security.Action.EDIT_RESERVATION, localStorage.getItem('user'))
      )
    );
  }

  renderSaveBtn = () => {
    if(this.isEditable()){
      return (
        <button
          className="btn btn-cust-blue mr-3"
          disabled={this.state.loading}
        >
          {this.state.loading && (
            <span className="spinner-border spinner-border-sm"></span>
          )}
          <span>Reservar</span>
        </button>
      );
    }
  }

  renderCancelBtnLabel = () => {
    return this.props.action == 'reserve' && this.state.lot.status != 'SOLD' ? 'Cancelar' : 'Volver';
  }

  delete = (e) => {
    e.preventDefault();
    const lot = this.state.lot;
    if(window.confirm('¿Estás seguro que deseas cancelar la reservación del lote ' + lot.name + '?') == true){
      this.setState({
        message: "",
        message_success: "",
        loading_cancel: true
      });
      let id = lot['_id'];
      if(id){
        cancelReservation(id).then(
          (res) => {
            if(res && res['transaction_id']){
              let lot = {...this.state.lot}
              lot.status = 'AVAILABLE';
              this.props.update(lot);
              this.props.close();
            }else{
              this.setState({
                loading_cancel: false,
                message: 'No se pudo cancelar la reservación del lote. Intenta nuevamente.'
              });
            }
          }
        );
      }else{
        this.setState({
          message: "",
          message_success: "",
          loading_cancel: false
        });
      }
    }
  }

  approve = (e) => {
    e.preventDefault();
    const lot = this.state.lot;
    if(window.confirm('¿Estás seguro que deseas aprobar la reservación del lote ' + lot.name + '?') == true){
      this.setState({
        message: "",
        message_success: "",
        loading_confirm: true
      });
      let id = lot['_id'];
      if(id){
        approveReservation(id).then(
          (res) => {
            if(res && res['transaction_id']){
              let lot = {...this.state.lot}
              lot.status = 'SOLD';
              lot.confirmed = true;
              this.props.update(lot);
              this.props.close();
            }else{
              this.setState({
                loading_confirm: false,
                message: 'No se pudo aprobar la reservación del lote. Intenta nuevamente.'
              });
            }
          }
        );
      }else{
        this.setState({
          message: "",
          message_success: "",
          loading_confirm: false
        });
      }
    }
  }

  renderCancelReservationBtn = () => {
    if(this.props.action == 'view_reservation' && methods.G_canDo(consts.Security.Action.CANCEL_RESERVATION, localStorage.getItem('user'))){
      return (
        <button className="btn btn-cust-orange float-left delete-lot" onClick={this.delete.bind(this)} disabled={this.state.loading_confirm || this.state.loading_cancel} >
          {this.state.loading_cancel && (
            <span className="spinner-border spinner-border-sm"></span>
          )}
          <span>Cancelar Reservación</span>
        </button>
      );
    }
  }

  renderConfirmReservationBtn = () => {
    if(this.props.action == 'view_reservation' && 
        methods.G_canDo(consts.Security.Action.APPROVE_RESERVATION, localStorage.getItem('user')) &&
        this.state.lot.hasOwnProperty('confirmed') && 
        this.state.lot.confirmed === false
        ){
      return (
        <button className="btn btn-cust-green float-left ml-3" onClick={this.approve.bind(this)} disabled={this.state.loading_confirm || this.state.loading_cancel} >
          {this.state.loading_confirm && (
            <span className="spinner-border spinner-border-sm"></span>
          )}
          <span>Aprobar Reservación</span>
        </button>
      );
    }
  }

  rednerAgentName = (i) => {
    let label = '';
    
    if(this.state.agents && this.state.agents.length > 0 && this.state.agents[i]){
      const a = this.state.agents[i];
      label = this.renderName(a);
    }
    
    return label;
  }

  renderName = (a) => {
    let label = '';
    if(a){
      label = a.first_name ? a.first_name: '' ;
      label += a.last_name ? ' ' + a.last_name : '';
      label += a.last_name_2 ? ' ' + a.last_name_2 : '';
    }
    return label;
  }

  renderAgentsSelector = () => {
    if(this.props.action !== 'view_reservation'){
      let listAgents = [];
      if(this.state.agents && this.state.agents.length > 0){
        listAgents = this.state.agents.map((a, i) => {
          let label = this.rednerAgentName(i);
          let k = a.agent_id; 
          let t = a.type
          return (
            <option key={t+'_'+k} value={i}>{label}</option>
          );
        });
      }

      return (
        <Select className="form-control" name='agent_name' value={this.state.selected_agent != null ? this.state.selected_agent : ''} onChange={this.onChangeAgent} validations={[requiredIndex]} disabled={!this.isEditable()} >
          <option value="">Seleccionar...</option>
          {listAgents}
        </Select>
      )
    }else{
      return (
        <span><b>{this.renderName(this.state.reservation_agent)}</b></span>
      )
    }
    
  }

  onChangeCardPayment = () => {
    this.setState({
      card_payment: !this.state.card_payment,
      invalid_card: false,
      card_message: '',
      card_number: '',
      card_month: '',
      card_year: '',
      card_cvv: '',
    })
  }

  onChangeCardNumber = (e) => {
    if (/^\d+$/.test(e.target.value) || e.target.value == '') {
      this.setState({
        card_number: e.target.value
      });
    }
  }

  onChangeCardYear = (e) => {
    if (/^\d+$/.test(e.target.value) || e.target.value == '') {
      this.setState({
        card_year: e.target.value
      });
    }
  }

  onChangeCardMonth = (e) => {
    if (/^\d+$/.test(e.target.value) || e.target.value == '') {
      this.setState({
        card_month: e.target.value
      });
    }
  }
  
  onChangeCardCVV = (e) => {
    if (/^\d+$/.test(e.target.value) || e.target.value == '') {
      this.setState({
        card_cvv: e.target.value
      });
    }
  }

  validateCardNumber = (e) => {
    this.setState({
      invalid_card: false,
      card_message: '',
    });

    let value = e.target.value;
    if (!value || value.length < 16 || value.length > 19) {
      this.setState({
        invalid_card: true,
        card_message: 'Ingresa un número de tarjeta válido.',
      });
      return false;
    }
  }

  validateYear = (e) => {
    let value = e.target.value;
    this.setState({
      invalid_card: false,
      card_message: '',
    });

    if (!value || parseInt(value) <= 0 || parseInt(value) > 99) {
      this.setState({
        invalid_card: true,
        card_message: 'Ingresa un año válido.',
      });
      return false;
    }
  }

  validateMonth = (e) => {
    let value = e.target.value;
    this.setState({
      invalid_card: false,
      card_message: '',
    });

    if (/^\d+$/.test(e.target.value) && parseInt(e.target.value) < 10 && e.target.value.length == 1 ) {
      value = '0' + e.target.value;
      this.setState({
        card_month: value
      });
    }
    
    if (!value || parseInt(value) <= 0 || parseInt(value) > 12) {
      this.setState({
        invalid_card: true,
        card_message: 'Ingresa un mes válido.',
      });
      return false;
    }
  }

  validateCVV = (e) => {
    let value = e.target.value;
    this.setState({
      invalid_card: false,
      card_message: '',
    });

    if (!value || value.length < 3 || value.length > 4) {
      this.setState({
        invalid_card: true,
        card_message: 'Ingresa un cvv válido.',
      });
      return false;
    }
  }

  validateCardValues = () => {
    this.setState({
      invalid_card: false,
      card_message: '',
    });

    let value = this.state.card_number;
    if (!value || value.length < 16 || value.length > 19) {
      this.setState({
        invalid_card: true,
        card_message: 'Ingresa un número de tarjeta válido.',
      });
      return false;
    }

    value = this.state.card_year;
    if (!value || parseInt(value) <= 0 || parseInt(value) > 99) {
      this.setState({
        invalid_card: true,
        card_message: 'Ingresa un día válido.',
      });
      return false;
    }

    value = this.state.card_month;
    if (!value || parseInt(value) <= 0 || parseInt(value) > 12) {
      this.setState({
        invalid_card: true,
        card_message: 'Ingresa un mes válido.',
      });
      return false;
    }

    value = this.state.card_cvv;
    if (!value|| value.length < 3 || value.length > 4) {
      this.setState({
        invalid_card: true,
        card_message: 'Ingresa un cvv válido.',
      });
      return false;
    }

    const d = new Date()
    const current_year = d.getFullYear().toString().substr(-2);
    
    if(parseInt(this.state.card_year) < parseInt(current_year)){
      this.setState({
        invalid_card: true,
        card_message: 'La fecha de vigencia ingresada ha expirado.',
      });
      return false;
    }else if(parseInt(this.state.card_year) == parseInt(current_year)){
      const current_month = d.getMonth() + 1;
      
      if(parseInt(this.state.card_month) <= parseInt(current_month)){
        this.setState({
          invalid_card: true,
          card_message: 'La fecha de vigencia ingresada ha expirado.',
        });
        return false;
      }
    }

    return true;
  }

  renderCardPayment = () => {
    
    if(this.state.payments && this.state.payments.length > 0){

      let approved = this.state.payments.find(x => x.status_id == 'APPROVED');

      if(approved.stripe_card){
        return (
          <div className="form-group">
            <b>{approved.stripe_card.brand} **** **** **** {approved.stripe_card.last_four}</b> - <a href={approved.stripe_card.receipt_url} target="_blank">Ver Recibo</a>
          </div>
        );
      }
      
    }
    return '';
  }

  renderDiscount = () => {
    if(this.state.lot.discount && this.state.lot.discount > 0){
      return (
        <Col sm="4 mt-2 mb-2">
          <b>Descuento:</b> {this.renderSimplePrice(this.state.lot.discount)}
        </Col>
      );
    }
  }

  editablePrice = () => {
    return this.props.lot.price ? true : false;
  }

  editableDiscount = () => {
    return ((this.state.payment.discount && this.state.payment.discount > 0) || (this.state.lot.discount && this.state.lot.discount > 0));
  }

  renderDiscountInput = () => {
    if(((this.state.payment.discount && this.state.payment.discount > 0) || (this.state.lot.discount && this.state.lot.discount > 0))){
      return (
        <Col sm="4">
          <div className="form-group">
            <label htmlFor="discount">Descuento (MXN)</label>
            <Input
              type="number"
              className="form-control"
              name="discount"
              value={this.state.payment.discount ? this.state.payment.discount : ( this.state.lot.discount ? this.state.lot.discount : '0')}
              onChange={this.onChangeDiscount}
              validations={[required,positiveNumber]}
              disabled={!this.isEditable() || this.editableDiscount()}
            />
          </div>
        </Col>
      )
    }
  }

  render() {
    return (
      <div className="containter">
        <Form
          onSubmit={this.handleSubmit}
          ref={c => {
            this.form = c;
          }}
        >
          <div className="row">
            <Col sm="4 mt-2 mb-2">
              <b>Nombre:</b> {this.state.lot.name }
            </Col>
            { this.props.development &&
              this.props.development.is_vertical &&
              this.state.lot.story_number &&
              <Col sm="4 mt-2 mb-2">
                <b>Piso:</b> {this.state.lot.story_number}
              </Col>
            }
            { this.props.development &&
              !this.props.development.is_vertical &&
              this.state.lot.block &&
              <Col sm="4 mt-2 mb-2">
                <b>Manzana:</b> {this.state.lot.block}
              </Col>
            }
            <Col sm="4 mt-2 mb-2">
              <b>Número:</b> {this.state.lot.number}
            </Col>
            <Col sm="4 mt-2 mb-2">
              {this.renderStatusLabel()}
            </Col>
            <Col sm="4 mt-2 mb-2">
              <b>Reserva con:</b> {this.renderSimplePrice(this.state.lot.price)}
            </Col>
            {this.renderDiscount()}
          </div>

          <hr/>
          <h5>Información del Cliente</h5>
          <div className="row">
            <Col sm="4">
              <div className="form-group">
                <label htmlFor="first_name">Nombre</label>
                <Input
                  type="text"
                  className="form-control"
                  name="first_name"
                  value={this.state.buyer.first_name}
                  onChange={this.onChangeFirstName}
                  validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="4">
              <div className="form-group">
                <label htmlFor="last_name">Apellido Paterno</label>
                <Input
                  type="text"
                  className="form-control"
                  name="last_name"
                  value={this.state.buyer.last_name}
                  onChange={this.onChangeLastName}
                  validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="4">
              <div className="form-group">
                <label htmlFor="last_name_2">Apellido Materno</label>
                <Input
                  type="text"
                  className="form-control"
                  name="last_name_2"
                  value={this.state.buyer.last_name_2}
                  onChange={this.onChangeLastName2}
                  //validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="email">Email</label>
                <Input
                  type="email"
                  className="form-control"
                  name="email"
                  value={this.state.buyer.email}
                  onChange={this.onChangeEmail}
                  validations={[required, email]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="phone">Teléfono</label>
                <Input
                  type="text"
                  className="form-control"
                  name="phone"
                  value={this.state.buyer.phone}
                  onChange={this.onChangePhone}
                  validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
          </div>
          <hr/>
          <h5>Dirección</h5>
          <div className="row">
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="country">País</label>
                <Input
                  type="text"
                  className="form-control"
                  name="country"
                  value={this.state.address.country ? this.state.address.country : ''}
                  onChange={this.onChangeCountry}
                  validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="state">Estado</label>
                <Input
                  type="text"
                  className="form-control"
                  name="state"
                  value={this.state.address.state ? this.state.address.state : ''}
                  onChange={this.onChangeState}
                  validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="city">Ciudad</label>
                <Input
                  type="text"
                  className="form-control"
                  name="city"
                  value={this.state.address.city ? this.state.address.city : ''}
                  onChange={this.onChangeCity}
                  validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="city">Calle y Número</label>
                <Input
                  type="text"
                  className="form-control"
                  name="line_1"
                  value={this.state.address.line_1 ? this.state.address.line_1 : ''}
                  onChange={this.onChangeLine1}
                  validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="city">Colonia</label>
                <Input
                  type="text"
                  className="form-control"
                  name="line_2"
                  value={this.state.address.line_2 ? this.state.address.line_2 : ''}
                  onChange={this.onChangeLine2}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
            <Col sm="6">
              <div className="form-group">
                <label htmlFor="zip_code">Código Postal</label>
                <Input
                  type="text"
                  className="form-control"
                  name="zip_code"
                  value={this.state.address.zip_code ? this.state.address.zip_code : ''}
                  onChange={this.onChangeZipCode}
                  validations={[required]}
                  disabled={!this.isEditable()}
                />
              </div>
            </Col>
          </div>
          <hr/>
          <h5>Información del Pago</h5>
          <div className="row mb-4">
            <Col sm="12">
              <div className="form-group">
                <label htmlFor="agent">Vendedor</label>
                {this.renderAgentsSelector()}
              </div>
            </Col>
            {
              <Col sm="4">
                <div className="form-group">
                  <label htmlFor="price">Reserva con (MXN)</label>
                  <Input
                    type="number"
                    className="form-control"
                    name="price"
                    value={this.state.payment.price ? this.state.payment.price : ( this.state.lot.price ? this.state.lot.price : '0')}
                    onChange={this.onChangePrice}
                    validations={[required,positiveNumber]}
                    disabled={!this.isEditable() || this.editablePrice()}
                  />
                </div>
              </Col>
            }
            {this.renderDiscountInput()}
            <Col sm="4">
              <div className="form-group">
                <label htmlFor="total">Total (MXN)</label>
                <Input
                  type="number"
                  className="form-control"
                  name="total"
                  value={this.state.payment.total ? this.state.payment.total : '0'}
                  validations={[required]}
                  disabled
                />
              </div>
            </Col>

            <Col sm="12">
              <div className="form-group">
                <label htmlFor="notes">Notas</label>
                <TextArea
                  className="form-control"
                  name="notes"
                  value={this.state.payment.notes ? this.state.payment.notes : ''}
                  onChange={this.onChangeNotes}
                  disabled={!this.isEditable()}
                  rows='4'
                />
              </div>
            </Col>
          </div>

          <hr/>
          <div className="row">
            <Col sm="6">
              <h5 className="card-switch">
                <BSForm.Check 
                  type="switch"
                  id="cerdit-card-switch"
                  label="Pago con Tarjeta"
                  checked={this.state.card_payment}
                  onChange={this.onChangeCardPayment}
                  disabled={!this.isEditable()}
                />
              </h5>
            </Col>
          </div>
          { this.state.card_payment && this.props.action == 'reserve' && this.state.lot.status != 'SOLD' && 
          <div className="row mb-4">
            <Col sm="7">
              <div className="form-group">
                <label htmlFor="card_number">Número de la Tarjeta</label>
                <div className="input-group">
                  <input 
                    value={this.state.card_number ? this.state.card_number : ''} 
                    type="text" 
                    className="form-control" 
                    name="card_number" 
                    onChange={this.onChangeCardNumber} 
                    maxLength={19}
                    onBlur={this.validateCardNumber}
                  />
                  
                </div>
              </div>
            </Col>
            <Col xs="3">
              <div className="form-group">
                <label>Vigencia</label>
                <div className="input-group">
                  <input 
                    value={this.state.card_month ? this.state.card_month : ''} 
                    type="text" 
                    className="form-control" 
                    name="card_month" 
                    onChange={this.onChangeCardMonth} 
                    maxLength={2} 
                    placeholder="MM"
                    onBlur={this.validateMonth}
                  />
                  <input 
                    value={this.state.card_year ? this.state.card_year : ''} 
                    type="text" 
                    className="form-control" 
                    name="card_year" 
                    onChange={this.onChangeCardYear} 
                    maxLength={2} 
                    placeholder="YY"
                    onBlur={this.validateYear}
                  />
                </div>
              </div>
            </Col>

            <Col xs="2">
              <div className="form-group">
                <label htmlFor="card_cvv">CVV</label>
                <div className="input-group">
                  <input 
                    value={this.state.card_cvv ? this.state.card_cvv : ''} 
                    type="password" 
                    className="form-control" 
                    name="card_cvv" 
                    onChange={this.onChangeCardCVV} 
                    maxLength={4}
                    onBlur={this.validateCVV}
                  />
                </div>
              </div>
            </Col>
            {
              this.state.invalid_card &&
              <Col xs="12">
                <div className="alert alert-danger" role="alert">
                  {this.state.card_message}
                </div>
              </Col>
            }
          </div>
          }
          { !this.state.card_payment && this.props.action == 'reserve' && this.state.lot.status != 'SOLD' && 
          <div className="row mb-4">
            <Col sm="12">
              <p>
                <b>Nota:</b> Al finalizar la reservación del lote con otro método de pago, el estatus del lote quedará como <b>"Apartado en Proceso"</b>.
              </p> 
              <p>
                Favor de comuncarse con el administrador del sistema para que la reservación sea aprobada.
              </p>
            </Col>
          </div>
          }
          { !this.state.card_payment && this.props.action == 'view_reservation' && this.state.lot.status == 'SOLD' && 
            methods.G_canDo(consts.Security.Action.APPROVE_RESERVATION, localStorage.getItem('user')) &&
            this.state.lot.hasOwnProperty('confirmed') && 
            this.state.lot.confirmed === false &&
          <div className="row mb-4">
            <Col sm="12">
              <p>
                <b>Nota:</b> La reservación de este lote aún no está aprobada.
              </p>
            </Col>
          </div>
          }
          { this.state.card_payment && this.state.lot.status == 'SOLD' && 
          <div className="row mb-4">
            <Col sm="12">
              {this.renderCardPayment()}
            </Col>
          </div>
          }

          {this.state.message && (
            <div className="form-group">
              <div className="alert alert-danger" role="alert">
                {this.state.message}
              </div>
            </div>
          )}

          {this.state.message_success && (
            <div className="form-group">
              <div className="alert alert-success" role="alert">
                {this.state.message_success}
              </div>
            </div>
          )}
          

          <div className="form-group text-right">

            {this.renderCancelReservationBtn()}
            {this.renderConfirmReservationBtn()}

            {this.renderSaveBtn()}
          
            <button className="btn btn-cust-red" onClick={this.props.close}>{this.renderCancelBtnLabel()}</button>
          </div>

          <CheckButton
            style={{ display: "none" }}
            ref={c => {
              this.checkBtn = c;
            }}
          />
        </Form>
      </div>
    );
  }

}

export default withRouter(ReservationForm);
